'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' });

var CropLandscape = function CropLandscape(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CropLandscape = (0, _pure2.default)(CropLandscape);
CropLandscape.muiName = 'SvgIcon';

exports.default = CropLandscape;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CropLandscape.js
// module id = 2293
// module chunks = 0